<template>
    <section>
        <!--工具条-->
        <el-col v-if="buttonList != null && buttonList.length > 0" :span="24" style="padding-bottom: 0px;">
            <el-form :inline="true" :model="search">
                <el-form-item label="物料类型信息">
                    <el-input v-model="search.title" placeholder="请输入物料类型信息"></el-input>
                </el-form-item>
                <el-form-item v-for="item in buttonList" v-bind:key="item.id">
                    <!-- 这里触发点击事件 -->
                    <el-button
                        :type="item.Func && (item.Func.toLowerCase().indexOf('handledel') != -1 || item.Func.toLowerCase().indexOf('stop') != -1) ? 'danger' : 'primary'"
                        v-if="!item.IsHide && (item.Func=='handlegetSapZtpp'|| item.Func== 'query')" @click="callFunc(item)">{{
                        item.name }}</el-button>
                </el-form-item>
            </el-form>
        </el-col>
<!-- 
        <el-col :span="24"> -->
            <!--列表-->
      <!--       <el-table :data="data" v-loading="listLoading" row-key="Id" style="width: 100%" ref="table" class="custom-tbl">
                <el-table-column type="index"  width="50" label="序号"> </el-table-column>
                <el-table-column prop="MATKL" label="物料组Id" width="150">
                </el-table-column>
                <el-table-column prop="ZDLBM" label="大类" width></el-table-column>
                <el-table-column prop="ZDLBM_TXT" label="大类名称" width></el-table-column>
                <el-table-column prop="ZZLBM" label="中类" width></el-table-column>
                <el-table-column prop="ZZLBM_TXT" label="中类名称" width></el-table-column>
                <el-table-column prop="ZXLBM" label="小类" width></el-table-column>
                <el-table-column prop="ZXLBM_TXT" label="小类名称" width></el-table-column>
                <el-table-column prop="CreateBy" label="创建用户" width></el-table-column>
                <el-table-column prop="CreateTimeString" label="创建时间" width></el-table-column>
            </el-table> -->
<!--         </el-col> -->
        <!--工具条-->
<!--         <el-col :span="24" class="toolbar">
            <el-pagination layout="total, sizes,prev, pager, next" @current-change="handleCurrentChange"
                @size-change="handleSizeChange" :current-page.sync="page" :page-size="intPageSize" :total="total"
                style="float: right"></el-pagination>
        </el-col> -->

         <el-col :span="24">
            <!--列表-->
            <el-table :data="SAPZTPPTreeList" v-loading="listLoading" row-key="Id" border lazy
                :tree-props="{ children: 'Children' }" style="width: 100%" ref="table" class="custom-tbl">
                <el-table-column type="index" width="80" label="序号"></el-table-column>
                <el-table-column prop="Id" label="类型名称" width></el-table-column>
                <el-table-column prop="Name" label="编号" width></el-table-column>
                <el-table-column prop="MATKL" label="所属物料组" width></el-table-column>
            </el-table>
        </el-col>
    </section>
</template>

<script>
    import {getButtonList} from "../../../promissionRouter";
    import {getSAPZTPPPageList,getGetSAP_ZTPP,getSAPZTPPTreeList} from '../../../api/api';
    export default {
        data() {
            return {
                buttonList:[],
                search: { title: "" },
                total: 0,
                page: 1,
                intPageSize:20,
                listLoading: false,
                data:[],
                
                //修改
                editFormVisible:false,  //窗口是否显示
                editLoading:false,   //loading显示
                editForm:{
                    Id: '',
                    PId:'',
                    Title:'',
                    Ioc: null,
                    FirstPng:null,
                    IocUrl: null,
                    FirstPngUrl:null
                },
                editFormRules: {
                    Title: [{ required: true, message: "请输入分类名称", trigger: "blur" }],
                },
                IocimgList:[],
                firtimgList:[],

                //所有二级分类
                TypeList:[],

                IsAdd:true, //是否
                component: "sapMatnrList",

                SAPZTPPTreeList:[]
            }
        },
        methods: {
            callFunc(item) {
                 this[item.Func].apply(this, item);
            },

            getSAPZTPPPageList() {
                 this.listLoading=true;
                let para = {
                    title: this.search.title,
                    page: this.page,
                    intPageSize:this.intPageSize,
                }
                getSAPZTPPPageList(para).then((res) => {
                    console.log(res);
                    this.total= res.data.response.dataCount;
                    this.data = res.data.response.data?res.data.response.data:[];
                    this.listLoading=false;
                })
            },
            handleCurrentChange(val) {
                this.page = val;
                this.getSAPZTPPPageList();
            },
            handleSizeChange(val){
               this.intPageSize = val;
               this.getSAPZTPPPageList();
            },
            load(tree, treeNode, resolve) {
                let para = {
                    page: this.page,
                    id: tree.Id,
                };
                getPermissionTreeTable(para).then((res) => {
                    resolve(res.data.response);
                });
            },
            //查询
            query()
            {
               console.log("查询")
               this.page = 1;
               this.hasChildren();
            },
            //更新数据
            handlegetSapZtpp()
            {
                 this.$confirm("确认更新物料类型信息吗？", "提示", {}).then(() => {
                    let para = {
                    };
                    console.log(para);
                    this.listLoading = true;
                    getGetSAP_ZTPP(para)
                    .then((res) => {
                        this.listLoading = false;
                        if (res.data.success) {
                        this.$message({
                            message: res.data.msg,
                            type: "success",
                        });
                        this.getSAPZTPPPageList();
                        } else {
                        this.$message({
                            message: res.data.msg,
                            type: "error",
                        });
                        }
                    })
                    .catch(() => {
                        this.listLoading = false;
                    });
                });
            },

            getSAPZTPPTreeList()
            {
                 let para = {
                    title: this.search.title,
                }
                this.listLoading=true;
                getSAPZTPPTreeList(para).then((res)=>{
                   this.SAPZTPPTreeList =  res.data.response
                   this.listLoading=false;
                });
            }
        },
        mounted() {
            let routers = window.localStorage.router
            ? JSON.parse(window.localStorage.router)
            : [];
            this.buttonList = getButtonList(this.$route.path, routers);
            //this.getSAPZTPPPageList();
            this.getSAPZTPPTreeList();
        }
    }

</script>

<style>
    .role-item {
        cursor: pointer;
        padding: 10px;
    }

    .role-item.active {
        background: #ebf5ff;
    }

    .role-item:hover {
        background: #ebf5ff;
    }

    .custom-tree-node {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding-right: 8px;
    }

    .text {
        font-size: 14px;
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }

    .clearfix:after {
        clear: both
    }

    .box-card {
        width: 90%;
    }


    .morechildren .el-checkbox{
        margin-right: 5px !important;
        float: left;
    }
    .morechildren .el-checkbox-group{
        margin-left: 50px;
        padding: 5px;
    }
    .morechildren .el-tree-node__content{
        height: auto !important;
    }
</style>
